var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDuplicate = function SvgIconDuplicate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 16,
    height: 16,
    viewBox: "0 0 52 52"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 0H11a1 1 0 0 0-1 1v3H7a1 1 0 0 0-1 1v46a1 1 0 0 0 1 1h34a1 1 0 0 0 1-1v-3h3a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1m-5 50H8V6h23v8a1 1 0 0 0 1 1h8zM33 7.414 38.586 13H33zM44 46h-2V14c0-.022-.011-.041-.013-.063a1 1 0 0 0-.051-.257c-.011-.032-.019-.063-.034-.094a1 1 0 0 0-.196-.293l-9-9a1 1 0 0 0-.293-.196c-.031-.014-.062-.022-.094-.033a1 1 0 0 0-.258-.051C32.041 4.011 32.021 4 32 4H12V2h32z"
  })));
};
export default SvgIconDuplicate;